import React from "react";
import type { LabelProps } from "react-aria-components";
import { LabelContext, useContextProps } from "react-aria-components";

import { useFormTextSubstitution } from "components/Form/hooks";

type FieldLabelProps = {
  text: string;
} & LabelProps;

const FieldLabel = React.forwardRef<HTMLLabelElement, FieldLabelProps>(
  ({ text, ...props }, ref) => {
    // Merge the local props and ref with the ones provided via context.
    [props, ref] = useContextProps(props, ref, LabelContext);

    const { substituteVariables } = useFormTextSubstitution();
    // Explicitly remove elementType from the props passed to the label.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { elementType, ...labelProps } = props;

    return (
      <label
        {...labelProps}
        ref={ref}
        className="mb-6 block text-3xl font-bold text-evergreen"
      >
        {substituteVariables(text)}
      </label>
    );
  },
);

FieldLabel.displayName = "FieldLabel";

export default FieldLabel;
